// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"72d74850","228":"60ed6528","292":"ac2dd4bd","624":"c4a15ce3","831":"326d7ea5"}[chunkId] + ".css";
};